export var mutations = {
    setLoadingState: function (state, loading) {
        state.loading = loading;
    },
    setCompany: function (state, company) {
        state.company = company;
    },
};
export var types = {
    SET_LOADING: 'setLoadingState',
    SET_COMPANY: 'setCompany',
};
